import Notifier from 'common/helpers/Notifier';
import getCoreError from 'src/api/utils/getCoreError';

export default function onError(error) {
  Notifier.handleErrors(getCoreError(error));
  return error;
}
